<template>
  <el-card class="box-card my-account">
    <el-tabs v-model="active">
      <el-tab-pane label="User Info" name="user-info" class="user-info">
        <el-row class="main-info" :gutter="20">
          <el-col :span="12" class="left">
            <h2 class="subtitle">Account Information</h2>
            <div class="border mt-2" :class="{ pending: org.erp_status === 11 }">
              <div class="form-group form-light">
                <label class="label">User Name :</label>
                <label class="label value">{{ account_info.username }}</label>
              </div>
              <div class="form-group form-light">
                <label class="label">Email :</label>
                <label class="label value" v-if="org.erp_status === 11">
                  <a>{{ account_info.email }}</a>
                </label>
                <label class="label value" v-else>
                  <a @click="emailDialogVisible = true">
                    <i class="icon-y-edit"></i>
                    {{ account_info.email }}
                  </a>
                </label>
              </div>
              <div class="form-group form-light" v-if="this.isAff()">
                <label class="label">Password :</label>
                <label class="label value">
                  <a @click="dialogVisible = true">
                    <i class="icon-y-edit"></i>
                    Modify
                  </a>
                </label>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <span class="subtitle">Your Affiliate Manager</span>
              <span class="ml-5 contact-tip" v-if="org.erp_status === 11">
                <i class="icon-y-info mr-2"></i>
                Contact our AM to active your account after registration.
              </span>
            </div>
            <div class="border mt-2" :class="{ pending: org.erp_status === 11 }">
              <div v-if="org.erp_status !== 11">
                <div class="am-contact">
                  <div class="avatar">
                    <img :src="org.am_contact.avatar" alt="" />
                  </div>
                  <div class="contact">
                    <p class="name">{{ org.am_contact.name_en }}</p>
                    <p class="skype">
                      <i class="icon-y-skype"></i>
                      <span>{{ org.am_contact.skype }}</span>
                    </p>
                    <p class="email">
                      <i class="icon-y-email2"></i>
                      <span>{{ org.am_contact.email }}</span>
                    </p>
                  </div>
                  <div class="tip">
                    <i class="icon-y-info"></i>
                    <p>If you have any questions, please contact us by Teams or email.</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-for="(am, index) in am_list" :key="index" class="am-list">
                  <el-row>
                    <el-col :span="12">
                      <div class="form-group form-light">
                        <i class="icon-y-fullname icon-grey mr-2"></i>
                        <label class="label-grey">{{ am.name }}</label>
                      </div>
                      <div class="form-group form-light" v-if="isAff()">
                        <i class="icon-y-skype icon-grey mr-2"></i>
                        <label class="label-grey">{{ am.skype }}</label>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="form-group form-light">
                        <i class="icon-y-email2 icon-grey mr-2"></i>
                        <label class="label-grey">{{ am.email }}</label>
                      </div>
                      <div class="form-group form-light" v-if="isAff()">
                        <i class="icon-y-whatsapp icon-grey mr-2"></i>
                        <label class="label-grey">{{ am.whatsapp }}</label>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-form
          v-loading="edit_loading"
          ref="account_org"
          :model="org_new"
          :rules="formRules"
          class="detail-info"
        >
          <h2 class="subtitle">Other Information</h2>
          <div class="border mt-2">
            <div class="form-group form-light" v-if="this.isAff()">
              <label class="label">Account Type</label>
              <label class="label value">
                {{ org.account_type ? 'Company' : 'Individual/Team' }}
              </label>
            </div>
            <div class="form-group form-light">
              <label class="label">Company</label>
              <label class="label value">{{ org.company }}</label>
            </div>
            <div class="form-group form-light" v-if="this.isAff()">
              <label class="label">
                Traffic Type
                <i v-if="user_info_edit" class="required-mark">*</i>
              </label>
              <label class="label value" v-if="!user_info_edit">
                {{
                  org.customer_type
                    ? org.customer_type === 11
                      ? 'SDK'
                      : org.customer_type === 12
                      ? 'SDK3'
                      : org.customer_type === 13
                      ? 'Interactive Ads'
                      : 'Network'
                    : 'Affiliate'
                }}
              </label>
              <div class="form-control" v-else>
                <el-select v-model="org_new.customer_type" placeholder="Traffic Type">
                  <el-option
                    v-for="item in regist.customer_type"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group form-light" v-if="org.timezone">
              <label class="label">
                Time Zone
                <i v-if="user_info_edit" class="required-mark">*</i>
              </label>
              <label class="label value" v-if="!user_info_edit">
                {{ org.timezone.gmt }} {{ org.timezone.location }}
              </label>
              <div class="form-control" v-else>
                <el-select v-model="org_new.timezone" placeholder="Timezone" value-key="id">
                  <el-option
                    v-for="item in timezone"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group form-light">
              <label class="label">
                Country
                <i v-if="user_info_edit" class="required-mark">*</i>
              </label>
              <label class="label value" v-if="!user_info_edit">{{ org.country }}</label>
              <div class="form-control" v-else>
                <el-select
                  v-model="org_new.country"
                  value-key="code"
                  placeholder="Country"
                  filterable
                >
                  <el-option
                    v-for="item in country"
                    :key="item.code"
                    :label="item.code_name"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="form-group form-light contact">
              <label class="label">
                Teams / QQ
                <i v-if="user_info_edit" class="required-mark">*</i>
              </label>
              <label class="label value" v-if="!user_info_edit && org.contact.data">
                {{ org.contact.contact_type ? 'QQ:' : 'Teams:' }} {{ org.contact.data }}
              </label>
            </div>
            <div class="form-group form-light">
              <label class="label">
                City
                <i v-if="user_info_edit" class="required-mark">*</i>
              </label>
              <label class="label value" v-if="!user_info_edit">{{ org.city }}</label>
              <el-form-item class="form-control" prop="city" v-else>
                <el-input v-model="org_new.city"></el-input>
              </el-form-item>
            </div>
            <div class="form-group form-light">
              <label class="label">
                Address
                <i v-if="user_info_edit" class="required-mark">*</i>
              </label>
              <label class="label value" v-if="!user_info_edit">{{ org.address }}</label>
              <el-form-item class="form-control" prop="address" v-else>
                <el-input v-model="org_new.address"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mt-8 center" v-if="this.isAff()">
            <div v-if="!user_info_edit">
              <el-tooltip
                enterable
                :visible-arrow="false"
                content="The account is under review and cannot be modified."
                placement="top"
                :disabled="org.erp_status != 11"
                popper-class="tooltip_popper"
              >
                <span>
                  <el-button
                    type="primary"
                    @click="editUserInfo()"
                    :disabled="org.erp_status == 11"
                  >
                    Edit
                  </el-button>
                </span>
              </el-tooltip>
            </div>
            <div v-else>
              <el-button type="primary" @click="updateUserInfo()" :disabled="user_info_submit">
                Save
              </el-button>
              <el-button type="danger" @click="canceEditUserInfo()">Cancel</el-button>
            </div>
          </div>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="API Key" name="apikey" class="referral" v-if="this.isAff()">
        <div class="form-group form-light">
          <label class="label">
            API Key
            <el-tooltip
              placement="top"
              enterable
              content="Click here to get the Secret Key"
              :visible-arrow="false"
              popper-class="tooltip_popper"
            >
              <i class="icon-y-question ml-1"></i>
            </el-tooltip>
          </label>
          <label class="label value">{{ apikeycode }}</label>
          <el-button
            type="primary"
            size="mini"
            v-clipboard:copy="apikeycode"
            v-clipboard:success="onCopy"
          >
            Copy
          </el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Referral" name="referral" class="referral" v-if="this.isAff()">
        <div class="form-group form-light">
          <label class="label">
            Referral Link
            <el-tooltip
              placement="top"
              enterable
              content="Earn referral bonus by sharing your exclusive link to others."
              :visible-arrow="false"
              popper-class="tooltip_popper"
            >
              <i class="icon-y-question ml-1"></i>
            </el-tooltip>
          </label>
          <label class="label value">{{ referralcode }}</label>
          <el-button
            type="primary"
            size="mini"
            v-clipboard:copy="referralcode"
            v-clipboard:success="onCopy"
          >
            Copy
          </el-button>
        </div>
        <section class="mt-12">
          <h4 class="title">Records of Referral</h4>
          <el-row type="flex" :gutter="20" align="center">
            <el-col :span="8">
              <label class="ym-label">Range</label>
              <el-date-picker
                v-model="referral_params.date"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="to"
                start-placeholder="Start"
                end-placeholder="End"
              ></el-date-picker>
            </el-col>
            <el-col :span="6" class="filter-run">
              <el-button type="primary" @click="getReferralList()">Run</el-button>
              <el-button type="dashed" @click="handleJump">More</el-button>
            </el-col>
          </el-row>

          <el-table
            border
            :data="referal_list"
            class="mt-5"
            empty-text="No Data"
            v-loading="referral_loading"
          >
            <el-table-column prop="create_date" label="Recommend Date"></el-table-column>
            <el-table-column prop="uid" label="Recommend Aff"></el-table-column>
          </el-table>
          <div class="note">
            <p>
              <i class="required-mark">*</i>
              Note:
            </p>
            <p>
              1. You will get 3% referral commission on your referee's reconciliation statment. Once
              the referee's statement accumulates to more than 50,000 USD, you will get a 5%
              commission.
            </p>
            <p>
              2. This campaign is effective over a long period.
            </p>
            <p>
              3. You can withdraw the commission when we confirm the settlement with recommended
              developers.
            </p>
            <p>4. Any question please ask your AM.</p>
          </div>
          <pagination
            :page="page"
            @sizeChange="getReferralList()"
            @currentChange="getReferralList()"
          ></pagination>
        </section>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Change Password" :visible.sync="dialogVisible" width="620px">
      <el-form :model="psw" ref="changePsw" :rules="pswRules" class="change-psw">
        <div class="form-group">
          <label class="label">
            Original Password
            <i class="required-mark">*</i>
          </label>
          <el-form-item prop="original_psw">
            <el-input v-model="psw.original_psw" type="password"></el-input>
          </el-form-item>
        </div>
        <div class="form-group">
          <label class="label">
            New Password
            <i class="required-mark">*</i>
          </label>
          <el-form-item prop="new_psw">
            <el-input v-model="psw.new_psw" type="password"></el-input>
          </el-form-item>
        </div>
        <div class="form-group">
          <label class="label">
            Confirm Password
            <i class="required-mark">*</i>
          </label>
          <el-form-item prop="new_psw_again">
            <el-input v-model="psw.new_psw_again" type="password"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="changePsw">Save</el-button>
      </div>
    </el-dialog>

    <el-dialog title="Change Email" :visible.sync="emailDialogVisible" width="620px">
      <el-form :model="email_reset" ref="changeEmail" :rules="emailRules" class="change-email">
        <div class="form-group">
          <label class="label">
            New Email
            <i class="required-mark">*</i>
          </label>
          <el-form-item prop="new_email">
            <el-input v-model="email_reset.new_email" type="email"></el-input>
          </el-form-item>
        </div>
        <div class="form-group">
          <label class="label">
            Code
            <i class="required-mark">*</i>
          </label>
          <el-form-item prop="code">
            <el-input v-model="email_reset.code">
              <el-button slot="append" type="primary" @click="getCode">Get Code</el-button>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="emailDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="changeEmail">Save</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import pagination from '../../components/pagination.vue'
import { pageMixin } from '../../mixins/commonMixin'

export default {
  mixins: [pageMixin],
  computed: {
    ...mapState(['settings', 'timezone', 'country']),
    formRules() {
      let props = [
        {
          name: 'contact.data',
          max: 75,
        },
        {
          name: 'city',
          max: 32,
        },
        {
          name: 'address',
          max: 512,
        },
      ]
      let rules = {}
      for (let value of props) {
        rules[value.name] = [{ required: true, max: value.max, trigger: ['blur', 'change'] }]
        if (value.extra) {
          rules[value.name].push(value.extra)
        }
      }
      return rules
    },
    pswRules() {
      return {
        original_psw: [{ required: true, message: 'Can not be empty.', trigger: 'blur, change' }],
        new_psw: [
          { required: true, message: 'Can not be empty.', trigger: 'blur, change' },
          {
            validator: (rule, value, callback) => {
              if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[._0-9A-Za-z]{6,16}$/.test(value)) {
                callback(
                  new Error(
                    'The password must be between 6-16 characters and include letters &numbers.'
                  )
                )
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change'],
          },
        ],
        new_psw_again: [
          { required: true, message: 'Please enter the password again.', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.psw.new_psw) {
                callback(new Error('The password and confirmation do not match.'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change'],
          },
        ],
      }
    },
    emailRules() {
      return {
        code: [{ required: true, message: 'Can not be empty.', trigger: 'blur, change' }],
        new_email: [
          { required: true, message: 'Can not be empty.', trigger: 'blur, change' },
          { type: 'email', message: 'Please enter the correct email', trigger: ['blur, change'] },
        ],
      }
    },
  },
  components: {
    pagination,
  },
  data() {
    return {
      active: 'user-info',
      edit_loading: false,
      referral_loading: false,
      dialogVisible: false,
      emailDialogVisible: false,
      account_info: {},
      org: {
        country: {},
        timezone: {},
        contact: {},
      },
      org_new: {
        contact: {},
      },
      user_info_edit: false,
      user_info_submit: false,
      regist: this.registData,

      psw: {
        original_psw: '',
        new_psw: '',
        new_psw_again: '',
      },
      email_reset: {},
      host: window.location.origin,
      referral_params: {
        date: ['2019-01-01 00:00:00', '2019-01-16 23:59:59'],
      },
      referralcode: '',
      referal_list: [],

      am_list: [
        {
          name: 'Doria',
          email: 'mkt@youmi.net',
          skype: 'mkt@youmi.net',
          whatsapp: '+86 18028539642',
        },
      ],
      apikeycode: '',
    }
  },
  created() {
    // 顶栏invite按钮
    if (this.$route.query.tab === '2') {
      this.active = 'referral'
    }else if(this.$route.query.tab === '1'){
      this.active = 'apikey'
    }

    this.getInfo()
    this.getAPIKEY()

    if (this.isAff()) {
      this.initReferral()
      this.getReferralList()
    }
    this.$store.dispatch('getTimezone')
    this.$store.dispatch('getCountry')
  },
  methods: {
    getAPIKEY() {
      this.$http.get('/api/aff/get-token/').then(res => {
        this.apikeycode = res.token
      })
    },
    handleJump() {
      this.$router.push('/commission')
    },
    getInfo() {
      this.$http.get('/accounts/user/info-r/').then(res => {
        this.account_info = res
        this.org = res.org || {}
        // this.org.timezone = res.timezone
        this.org_new = { ...this.org }

        this.referralcode = this.org.invitation_url
      })
    },
    editUserInfo() {
      this.updateInfo(this.$route.path, true)
      // this.user_info_edit = true
    },
    canceEditUserInfo() {
      this.user_info_edit = false
      this.user_info_submit = false
    },
    updateUserInfo() {
      if (!this.isFormValid('account_org')) {
        return
      }
      let org_new = this.org_new
      let { contact, country, timezone, ...params } = { ...org_new }
      params.country = org_new.country.code
      params.timezone = org_new.timezone.id
      params.contact_type = org_new.contact.contact_type
      params.contact = org_new.contact.data

      this.user_info_submit = true
      this.edit_loading = true
      this.$http
        .post('/accounts/user/edit-info-r/', params)
        .then(() => {
          this.edit_loading = false
          this.notifyOpen()
          this.org = { ...org_new }
          this.org.erp_status = 11
          this.user_info_edit = false
          this.user_info_submit = false
        })
        .catch(err => {
          this.edit_loading = false
          this.user_info_submit = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    changePsw() {
      if (!this.isFormValid('changePsw')) {
        return
      }
      let psw = this.psw
      this.$http
        .post('/accounts/modify-password/', {
          password: psw.new_psw,
          origin_password: psw.original_psw,
          confirm_password: psw.new_psw_again,
        })
        .then(() => {
          this.notifyOpen()
          this.Logout()
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    changeEmail() {
      if (!this.isFormValid('changeEmail')) {
        return
      }
      let email_reset = this.email_reset
      this.$http
        .post('/accounts/modify-email/', {
          code: email_reset.code,
          email: email_reset.new_email,
        })
        .then(() => {
          this.notifyOpen()
          this.Logout()
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    getCode() {
      this.$refs['changeEmail'].validateField('new_email', error => {
        if (!error) {
          let params = {
            email: this.email_reset.new_email,
            template: 'email_reset',
          }
          this.$http
            .post('/accounts/email-send/', params)
            .then(res => {
              this.notifyOpen()
            })
            .catch(err => {
              this.notifyOpen('Error', this.executeError(err), 'error')
            })
        } else {
          return undefined
        }
      })
    },
    initReferral() {
      let date_end = new Date()
      let end_time =
        date_end.toISOString().split('T')[0] + ' ' + date_end.toTimeString().slice(0, 8)
      date_end.setMonth(date_end.getMonth() - 3)
      let start_time =
        date_end.toISOString().split('T')[0] + ' ' + date_end.toTimeString().slice(0, 8)
      this.referral_params.date = [start_time, end_time]
    },
    getReferralList() {
      let params = this.referral_params
      if (!params.date) {
        params.date = ['2000-01-01 00:00:00', '2019-01-16 23:59:59']
      }
      this.referral_loading = true
      this.$http
        .get('/api/aff/recommend-list/', {
          params: {
            p: this.page ? this.page.cur : 1,
            n: this.page ? this.page.per : 25,
            // status: params.status,
            create_start: params.date[0].split(' ')[0],
            create_end: params.date[1].split(' ')[0],
          },
        })
        .then(res => {
          this.referral_loading = false
          this.referal_list = res.data
          this.changePageItem(this.page, res)
        })
        .catch(err => {
          this.referral_loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
  },
}
</script>
<style lang="scss">
.my-account {
  .form-group {
    height: 32px;
    margin-bottom: 10px;
  }
  .user-info {
    .form-group .label {
      width: 120px;
    }
  }
  .subtitle {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #37383a;
    line-height: 24px;
  }
  .am-contact {
    display: flex;
    .avatar {
      width: 80px;
      height: 80px;
      border: 2px solid #fff;
      box-shadow: 0px 3px 4px 3px rgba(33, 35, 41, 0.08);
      border-radius: 50%;
      margin-right: 24px;
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }
    .contact {
      .name {
        color: #525356;
        font-weight: 600;
        margin-bottom: 8px;
      }
      .skype,
      .email {
        display: flex;
        color: #828488;
        font-size: 14px;
        margin-bottom: 8px;
        i {
          font-size: 16px;
          color: #d0d3d9;
          margin-right: 4px;
        }
      }
    }
    .tip {
      display: flex;
      background-color: #f5f7fa;
      width: 200px;
      border-radius: 4px;
      padding: 10px 12px;
      font-size: 14px;
      color: #9b9ea3;
      margin-left: 30px;
      i {
        font-size: 16px;
        color: #d0d3d9;
        margin-right: 4px;
      }
    }
  }
  .business-name {
    color: #38383a;
    line-height: 22px;
    font-size: 14px;
  }
  .label-grey {
    font-weight: 400;
    font-size: 14px;
    color: #6b6d71;
    line-height: 22px;
  }
  .icon-grey {
    font-size: 16px;
    color: #d0d3d9;
    line-height: 22px;
  }
  .border {
    border: 1px solid #eef0f6;
    padding: 20px 36px 12px;
  }
  .main-info {
    display: flex;
    align-items: flex-start;
    position: relative;
    .el-col {
      margin-bottom: 0;
    }
    .border {
      height: 160px;
      overflow-y: auto;
    }
    .pending {
      height: 300px;
    }
    .form-group {
      height: 25px;
      margin-bottom: 0;
    }
    .am-list {
      padding-bottom: 16px;
      border-bottom: 1px solid #e4e7ed;
      &:last-child {
        border-bottom: none;
      }
    }
    .contact-tip {
      font-size: 12px;
      color: #9b9ea3;
      line-height: 20px;
      .icon-y-info {
        color: #c0c4cc;
      }
    }
  }
  .detail-info {
    margin-top: 40px;
    .contact {
      margin-top: 10px;
      &.form-group {
        height: auto;
      }
      .el-radio-group {
        height: auto;
        margin-bottom: 5px;
      }
      .el-form-item__error {
        height: 32px;
        top: 23px;
      }
    }
  }
  .form-control {
    width: 250px;
  }
  .change-psw,
  .change-email {
    .el-form-item {
      width: 60%;
    }
    .form-group {
      margin-bottom: 20px;
      .label {
        width: 150px;
      }
    }
    .el-form-item__error {
      height: 32px;
      left: -5px;
      top: 24px;
    }
  }
  .change-email {
    .el-input-group__append {
      background: #0080cc;
      color: #ffffff;
      transition: all 0.2s ease;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .referral {
    .title {
      padding: 10px 0;
      margin: 10px 0;
      border-bottom: 1px solid #e4e7ed;
    }
    .filter-run {
      line-height: 38px;
    }
  }
  .note {
    margin-top: 23px;
    color: #9b9ea3;
    font-size: 12px;
    line-height: 18px;
  }
  .el-tabs__content {
    position: static;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .center {
    text-align: center;
  }
}
</style>
